import React from 'react';
import './RadioInput.scss';

const RadioInput = (props) => {
  const { label, isDisabled, ...restProps } = props;
  return (
    <label
      className={`custom-generic-radio-button ${
        isDisabled ? 'disable-me' : ''
      }`}
    >
      <input {...restProps} type="radio" />
      <span className={isDisabled ? 'checkmark-disabled' : 'checkmark'}></span>
      <span className="custom-radio-button-label">{label}</span>
    </label>
  );
};

export default RadioInput;
